export default __webpack_public_path__ + "static/media/1.1f6d2455.jpg";